import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import SettingsNumberInput from "../../../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useL10n } from "@ews/react-localization-context";

const InterventionTime: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();
    return <>
        <SettingsNumberInput
            text={t("TRVB_SWITCH_OFF_TIME_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_SWITCH_OFF_TIME_LABEL")} />}
            value={specification.interventionTime?.shutdownTime || 0}
            onBlur={({ value }) =>
            {
                if (specification.interventionTime?.shutdownTime === value) return;
                if (systemId && specification.interventionTime) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        interventionTime: {
                            ...specification.interventionTime,
                            shutdownTime: value
                        },
                    });
                }
            }
            } />
        <SettingsCheckbox
            text={t("TRVB_SPRINKLER_SYSTEM_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_SPRINKLER_SYSTEM_LABEL")} />}
            checked={specification.interventionTime?.sprinklerSystem || false}
            onChange={(checked) =>
            {
                if (specification.interventionTime?.sprinklerSystem === checked) return;
                if (systemId && specification.interventionTime) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        interventionTime: {
                            ...specification.interventionTime,
                            sprinklerSystem: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_FIRE_COMPANY_FIRE_BRIGADE_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FIRE_COMPANY_FIRE_BRIGADE_LABEL")} />}
            checked={specification.interventionTime?.fullTimeCompanyFireBrigade || false}
            onChange={(checked) =>
            {
                if (specification.interventionTime?.fullTimeCompanyFireBrigade === checked) return;
                if (systemId && specification.interventionTime) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        interventionTime: {
                            ...specification.interventionTime,
                            fullTimeCompanyFireBrigade: checked
                        },
                    });
                }
            }} />
    </>;
};

export default InterventionTime;
